import $ from 'jquery';
import Cookies from 'js-cookie';

import { FireComponent } from '@base';

export class Events extends FireComponent {
  constructor(id) {
    super(id);
  }

  static get COOKIE_KEY() {
    return {
      VIEW_COOKIE: 'OSUALUMNI.EVENTS.view_cookie',
    };
  }

  get cookies() {
    return {
      view_cookie: Cookies.get(Events.COOKIE_KEY.VIEW_COOKIE),
    };
  }

  get elements() {
    return {
      $wrapper: this.$component.find('[data-events-wrapper]'),
      $toggleGrid: this.$component.find('[data-view-toggle-grid]'),
      $toggleList: this.$component.find('[data-view-toggle-list]'),
    };
  }

  _breadcrumb() {
    // hide default breadcrumb
    if ($('.bux-breadcrumb').length) {
      $('.bux-breadcrumb').each(function (index, element) {
        if (index === 0) {
          $(element).remove();
        }
      });
    }
  }

  _toggleView() {
    this.elements.$toggleGrid.on('click', (event) => {
      this.elements.$wrapper.addClass('grid').removeClass('list');
      $(event.target).addClass('active').siblings().removeClass('active');
      $(event.target).attr('aria-pressed', 'true');
      $(event.target).siblings().attr('aria-pressed', 'false');

      Cookies.set(Events.COOKIE_KEY.VIEW_COOKIE, 'grid', { expires: 1 });
    });

    this.elements.$toggleList.on('click', (event) => {
      this.elements.$wrapper.addClass('list').removeClass('grid');
      $(event.target).addClass('active').siblings().removeClass('active');
      $(event.target).attr('aria-pressed', 'true');
      $(event.target).siblings().attr('aria-pressed', 'false');

      Cookies.set(Events.COOKIE_KEY.VIEW_COOKIE, 'list', { expires: 1 });
    });
  }

  _cookieCheck() {
    if (this.cookies.view_cookie == 'grid') {
      this.elements.$wrapper.addClass('grid').removeClass('list');
      this.elements.$toggleGrid.addClass('active').siblings().removeClass('active');

      this.elements.$toggleGrid.get(0).setAttribute('aria-pressed', 'true');
      this.elements.$toggleList.get(0).setAttribute('aria-pressed', 'false');
    } else if (this.cookies.view_cookie == 'list') {
      this.elements.$wrapper.addClass('list').removeClass('grid');
      this.elements.$toggleList.addClass('active').siblings().removeClass('active');

      this.elements.$toggleList.get(0).setAttribute('aria-pressed', 'true');
      this.elements.$toggleGrid.get(0).setAttribute('aria-pressed', 'false');
    }
  }

  init() {
    if (!this.componentExists) return;

    this._breadcrumb();
    this._toggleView();
    this._cookieCheck();

    $(document).on('ajaxComplete', () => {
      this._cookieCheck();
    });
  }
}
